<style src="./style.scss">

</style>

<ul id="d-ns-navigation" class="mbsc-cloak main-menu">
  {#if !Utils.isMobile()}
  <li data-id="0" data-tab="home" class="d-ns-logo">
    <img src="/images/logo-d-ns-studio.png" width="150px" height="auto" alt="D-NS logo" />
  </li>
  {/if}
  {#if stories}
    {#each stories as item, index}
    <li data-id="{index + 1}" data-tab="{item.path}">{item.name}</li>
    {/each}
  {/if}
</ul>

<script>
  import { onMount, afterUpdate, beforeUpdate, createEventDispatcher } from 'svelte';
  import { Utils, StoryBlok } from '@Services';
  import { Cache } from 'aws-amplify';

  export let selectedItem = 'home';
  export let path = null;

  const DEBUG = document.location.protocol === 'http:' ? true : false;
  const MENU_CACHE_KEY = 'd-ns-main-menu-stories';

  const dispatch = createEventDispatcher();

  const client = StoryBlok.getClient();
  const storyConf = StoryBlok.getRequestConfig();
  let stories = null;

  let mainMenu;
  let menuType = 'hamburger';

  let removeSelection = () => {
    for (let i = 1; i <= 5; i++) {
      mainMenu.deselect(i);
    }
  };

  let initializeMenu = () => {
    if (mainMenu === undefined) {
      if (stories === null) {
        return false;
      }
      mainMenu = mobiscroll.nav('#d-ns-navigation', {
        display: 'top',
        layout: 'fixed',
        type: menuType,
        onItemTap: (event, inst) => {
          if (event.target.dataset.disabled && event.target.dataset.disabled === 'true') {
            if (DEBUG) console.log('Menu is disabled, skip propagation.');
          }else{
            removeSelection();
            mainMenu.select(event.target.dataset.id);
            dispatch('menuTapped', {
              item: event.target.getAttribute('data-tab'),
              type: 'main',
            });
          }
        },
      });
      removeSelection();
      return true;
    }
    return false;
  };

  beforeUpdate(async () => {
    stories = Cache.getItem(MENU_CACHE_KEY);
    if (stories === null) {
      stories = await client.getAll('cdn/stories', storyConf);
      Cache.setItem(MENU_CACHE_KEY, stories);
    }
  });

  afterUpdate(() => {
    if (initializeMenu()) {
      if (path === null) {
        for (let i = 0; i < stories.length; i++) {
          if (stories[i].path === selectedItem) {
            mainMenu.select(i + 1);
            break;
          }
        }
      } else if (path === '/signup/'){
        mainMenu.select(4);
      } else if (path === '/instructores/'){
        mainMenu.select(3);
      } else if (path === '/my-account/'){
        mainMenu.select(5);
      } else if (path === '/clases/'){
        mainMenu.select(2);
      }
    }
  });

  onMount(async () =>{
    if (!Utils.isMobile()) {
      menuType = 'tab';
    }
    mobiscroll.settings = {
      theme: 'd-ns',
      themeVariant: 'light',
      lang: 'es'
    };
  });
</script>
